import React from 'react';

import { CrossIcon } from '@vlabs/icons';
import { Control, Divider } from '@vlabs/uikit';

import st from '../CheckboxCustomFilter.module.sass';

export const OptionItem = ({
  option,
  checked,
  isMulti,
  isCreated,
  onChange,
  onDelete,
  name,
}) => {
  const commonProps = {
    id: `${name}.${option.value}`,
    label: option.label || option.value,
  };

  return (
    <>
      <div className={st.OptionItem}>
        {isMulti ? (
          <Control.Checkbox
            {...commonProps}
            checked={checked}
            onChange={() => onChange(option)}
          />

        ) : (
          <Control.Radio
            {...commonProps}
            checked={checked}
            onChange={() => onChange(option)}
          />
        )}
        {isCreated && onDelete && (
          <Control.IconButton
            data-testid={`deleteOption-${option.value}`}
            icon={<CrossIcon />}
            kind="secondary"
            onClick={() => onDelete(option)}
            shape="round"
            size="small"
            variant="outlined"
          />
        )}
      </div>
      <Divider small />
    </>
  );
};
